/**
 * Define two endpoints:
 * E1: Authentication data
 * E2: Health Data
 */

const E1 = `${window?.config?.VUE_APP_API_LOGIN_URL}api`;
const E2 = `${window?.config?.VUE_APP_API_URL}api`;

/**
 * POST Requests for auth data (E1)
 */

export const ROUTE_API_SIGN_UP = `${E1}/register`;
export const ROUTE_API_REGISTER_TOKEN = `${E1}/registertoken`;
export const ROUTE_API_SIGN_IN = `${E1}/auth/signIn`;
export const ROUTE_API_GET_PRIVACY_STATEMENT = `${E1}/getPrivacy`;
export const ROUTE_API_GET_EDITHCARE_STATEMENT = `${E1}/getEdithCareStatement`;
export const ROUTE_API_POST_VALIDATION_ERRORS = `${E1}/validationErrors`;

export const ROUTE_API_GET_USER = `${E1}/v1/user`;
export const ROUTE_API_SIGN_OUT = `${E1}/v1/signOut`;
export const ROUTE_API_FORGET_PASSWORD = `${E1}/forgetPassword`;
export const ROUTE_API_RESET_PASSWORD = `${E1}/resetPassword`;
export const ROUTE_API_UPDATE_PASSWORD = `${E1}/v1/updatePassword`;
export const ROUTE_API_CONFIRM_EMAIL = `${E1}/confirmEmail`;
export const ROUTE_API_CHECK_PASSWORD = `${E1}/v1/checkPassword`;
export const ROUTE_API_DELETE_USER = `${E1}/v1/deleteAccount`;
export const ROUTE_API_CHANGE_USERDATA = `${E1}/v1/updateUserData`;
export const ROUTE_API_UPDATE_CONSENTS = `${E1}/v1/updateConsents`;
export const ROUTE_API_SAVE_UNREGISTERED_USER = `${E1}/saveUnregisteredUser`;
export const ROUTE_API_UNREGISTERED_USER_DOI = `${E1}/unregisteredUserDoi`;
export const ROUTE_API_EDITHCARE = `${E1}/v1/edithcare`;
export const ROUTE_API_GET_EDITHCARE_USER_CONSENT = `${E1}/v1/getEdithCareUserConsent`;

/**
 * POST Requests for health data (E2)
 */

export const ROUTE_API_GET_PROFILE = `${E2}/getProfile`;
export const ROUTE_API_REGISTER_USER = `${E2}/registerUser`;
export const ROUTE_API_GET_TASK_SCHEDULER = `${E2}/getTaskScheduler`;
export const ROUTE_API_SAVE_TASK_SCHEDULER = `${E2}/saveTaskScheduler`;
export const ROUTE_API_CLEAR_TASK_SCHEDULER = `${E2}/hiddenTaskScheduler`;
export const ROUTE_API_SAVE_CURRENT_TASK_SCHEDULER = `${E2}/saveOrUpdateCurrentTaskId`;
export const ROUTE_API_CHANGE_PROFILE = `${E2}/updateProfile`;
export const ROUTE_API_DELETE_PROFILE = `${E2}/deleteProfile`;
export const ROUTE_API_DELETE_HEALTH = `${E2}/deleteHealth`;
export const ROUTE_API_GET_CARE_LEVEL_DATA = `${E2}/getCareLevelWizard`;
export const ROUTE_API_GET_CARE_LEVEL_DATA_FROM_UUID = `${E2}/getCareLevelWizardFromUuid`;
export const ROUTE_API_GET_CARE_PROFILE_DATA = `${E2}/getCareProfile`;
export const ROUTE_API_UPDATE_CARE_LEVEL_DATA = `${E2}/saveForRegisteredUserCareLevelWizard`;
export const ROUTE_API_SAVE_UNREGISTERED_CARE_LEVEL_WIZARD = `${E2}/saveForUnregisteredUserCareLevelWizard`;
export const ROUTE_API_GET_CARE_LEVEL_WIZARD_PDF = `${E2}/getCareLevelWizardPdf`;
export const ROUTE_API_GET_CARE_LEVEL_WIZARD_PDF_UNREGISTERED = `${E2}/getUnregisteredCareLevelWizardPdf`;
export const ROUTE_API_UPDATE_CARE_PROFILE = `${E2}/updateCareProfile`;
export const ROUTE_API_GET_DISCLOSURE_DOWNLOAD = `${E2}/getDisclosureAsDownload`;
export const ROUTE_API_SAVE_CARE_SERVICE = `${E2}/saveCareService`;
export const ROUTE_API_GET_CARE_SERVICE = `${E2}/getCareService`;
export const ROUTE_API_GET_INSURANCES = `${E2}/getInsurances`;
export const ROUTE_API_SAVE_CARE_REQUEST = `${E2}/saveCareRequest`;
export const ROUTE_API_GET_CARE_REQUEST = `${E2}/getCareRequest`;
export const ROUTE_TRACKING_UNREGISTERED_USER = `${E2}/trackingUnregisteredUser`;
export const ROUTE_GET_EDITHCARE_DOCUMENTS = `${E2}/getEdithCareDocuments`;
export const ROUTE_GET_EDITHCARE_PDF = `${E2}/getEdithCareRequestPdf`;
